import React from 'react'
import { makeStyles, Hidden, Box, Typography, } from '@material-ui/core'
import video from "../../media/usa.mp4"
import blueCover from "../../media/blue.jpg"
import ScrollAnimation from 'react-animate-on-scroll';
import Typewriter from 'typewriter-effect';
const useStyles = makeStyles((theme) => ({

  videoText1: {
    color: theme.colors.orange,
    fontFamily: "Zen Dots,cursive",
    fontWeight: 700,
    fontSize: 40,
    zIndex: 13000,
    [theme.breakpoints.down("sm")]: {
      fontSize: "25px"
    }
  },
  videoText2: {
    color: theme.colors.orange,
    fontFamily: theme.font.fontFamily,
    fontWeight: 700,
    fontSize: "22px",
    marginTop: "30px",
    [theme.breakpoints.down("sm")]: {
      marginTop: "10px",
      fontSize: "16px"
    }
  },
  videoText3: {
    color: theme.colors.orange,
    fontWeight: 700,

    fontSize: "22px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px"
    }
  },
  SecondvideoText: {
    color: theme.colors.orange,
    fontWeight: 700,
    fontSize: "22px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1rem"
    }
  }
}))
function Video() {
  const classes = useStyles();
  return (
    <div>
      <Hidden smDown>
        <Box position="relative" height="100%" width="100%" overflow="hidden"  >
          <Box position="absolute" left="20%" top="20% " zIndex={2} maxWidth="1148px" mx="auto" overflow="hidden"  >
            <Typography className={classes.videoText1} >Know what’s going on behind cryptocurrency.</Typography>
            <Typography className={classes.videoText2} variant="h6">From AML to CTF, compliance risk and forensics.</Typography>
            <Typography className={classes.videoText3} variant="h6">We have you covered.</Typography>
          </Box>
          <video className="homeVideo" width="100%" height="100%" autoPlay muted loop style={{ opacity: "0.7" }}>
            <source src={video} type="video/mp4" />
          </video>
          <div className="gradient"></div>
        </Box>
      </Hidden>
      <Hidden mdUp>
        <Box position="relative" height="100%" width="100%" overflow="hidden"  >
          <Box position="absolute" left="10%" top="40% " mx="auto" overflow="hidden"  >
            <ScrollAnimation animateIn="slideInRight" animateOut='slideOutLeft'>
              <Typography className={classes.SecondvideoText} variant="h4">Know what’s going on behind cryptocurrency.</Typography>
              <Typography className={classes.SecondvideoText} variant="h6">From AML to CTF, compliance risk and forensics.</Typography>
              <Typography className={classes.SecondvideoText} variant="h6">We have you covered.</Typography>
            </ScrollAnimation>
          </Box>
          <div className="gradient"></div>
          <img src={blueCover} alt="" height="500px" width="100%" />
        </Box>
      </Hidden></div>
  )
}

export default Video
